// tslint:disable: array-type

/**
 * Remove items from an array. Only items which are not in the `remove` array
 * will be returned.
 *
 * @param array - The array to filter through
 * @param remove - The items to remove
 */
export function removeItems<T extends Array<any> = Array<any>>(array: T, remove: any | Array<any>): T {
	const toRemove: Array<T> = Array.isArray(remove) ? remove : [remove];

	return array.filter((a) => toRemove.indexOf(a) < 0) as T;
}

/**
 * Filter items from an array. Only items which are in the `allow` array will be
 * returned.
 *
 * @param array - The array to filter through
 * @param allow - The items to allow
 */
export function allowItems<T extends Array<any> = Array<any>>(array: T, allow: any | Array<any>): T {
	const toAllow: Array<T> = Array.isArray(allow) ? allow : [allow];

	return array.filter((a) => toAllow.indexOf(a) >= 0) as T;
}

/**
 * Check if the array contains any of the specified items.
 *
 * @param array - The array to filter through
 * @param contains - The items to check for
 */
export function containsItems(array: Array<any>, contains: any | Array<any>): boolean {
	const toContain: Array<any> = Array.isArray(contains) ? contains : [contains];

	return array.some((a) => toContain.indexOf(a) >= 0);
}
